import {
  Grid,
  Avatar,
  Stack,
  Tooltip,
  ListItem,
  ListItemText,
  Paper,
  List,
  ListItemAvatar,
  IconButton,
} from '@mui/material'

import sipLogo from '../../../assets/sip-logo.png'
import maxucLogo from '../../../assets/maxuc-logo.png'
import drLogo from '../../../assets/dr-logo.png'

import './cards.css'
import AddIcon from '@mui/icons-material/Add'
import PlayCircleIcon from '@mui/icons-material/PlayCircle'
import {
  checkPermission,
  getAvailableIconStatus,
  getMaxUCOrderIconStatus,
  stringAvatar,
} from '../../../helpers/HelperFunctions'
import { ORDER_STATUS_ENUM, PRODUCT_NAMES, SERVICE_PRODUCT_CODES,productPermissionCreate,productPermissionUpdate,productPermissionView } from '../../../helpers/Constants'
import { useCommonRedux } from '../../../store/middlewares/CommonRedux'
import { styled } from '@mui/system'

const StyledCaption = styled('span')(() => ({
  marginTop: '20px',
  fontWeight: 100,
  fontSize: '14px',
  lineHeight: 1.66,
  letterSpacing: 0.044,
  color: '#008000',
  paddingBottom: '5px',
}))

export default function ServiceProductCard(props) {
  const { dispatch, state: commonState } = useCommonRedux()

  const renderAvatar = (productCode, name) => {
    const avatarProps = {
      sx: { borderRadius: 0, width: 65, height: 65, margin: '0 15px 0 0' }
    };

    switch (productCode) {
      case SERVICE_PRODUCT_CODES.SipTrunking:
        return <Avatar {...avatarProps} src={sipLogo} />;
      case SERVICE_PRODUCT_CODES.DirectRouting:
        return <Avatar {...avatarProps} src={drLogo} sx={{ ...avatarProps.sx, width: 70 }} />;
      case SERVICE_PRODUCT_CODES.MaxCloudCoreView:
        return <Avatar {...avatarProps} src={maxucLogo} />;
      default:
        return (
          <Avatar
            {...avatarProps}
            {...stringAvatar(productCode === SERVICE_PRODUCT_CODES.DirectRouting ? PRODUCT_NAMES.TPS : name)}
          />
        );
    }
  };
 
  const renderActionIcon = (item) => {
    const canCreate = checkPermission(productPermissionCreate, commonState.currentCompanyDetails);
    const canModify = checkPermission(
      [...productPermissionCreate, ...productPermissionUpdate, ...productPermissionView],
      commonState.currentCompanyDetails
    );

    if (props.ordered && canModify) {
      return (
        <Tooltip title="Open Service">
          <IconButton 
          onClick={() => props.goToServiceFunction(item, false)}
          edge="end"
          aria-label="delete"
          >
            <PlayCircleIcon />
          </IconButton>
        </Tooltip>
      );
    } else if (!props.ordered && canCreate) {
      return (
        <Tooltip title="Create New Service">
          <IconButton 
          edge="end"
          aria-label="delete"
          onClick={() => props.goToServiceFunction(item, true)}
          >
            <AddIcon />
          </IconButton>
        </Tooltip>
      );
    }
    return null;
  };

  const getStatusLabel = (status) =>
    status ? getMaxUCOrderIconStatus(status) : getAvailableIconStatus();

  return (
    <>
      <Grid container spacing={2}>
        {props.data?.map((item, key) => (
          <Grid key={`Service_Grid_${key}`} item xs={12} sm={6} md={4} xl={3}>
            <Paper
              className={
                item.orderStatus == ORDER_STATUS_ENUM.Completed ||
                  !item.orderStatus
                  ? 'cardactive'
                  : 'cardinactive'
              }
              sx={{ backgroundColor: '#fff' }}
              elevation={8}
            >
              <div>
                <Stack
                  sx={{ p: '10px 20px', margin: 0 }}
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={0}
                >
                  <List style={{ width: '100%' }}>
                    <ListItem
                      disablePadding
                      secondaryAction={renderActionIcon(item)}
                    >
                      <ListItemAvatar>
                        {renderAvatar(item.productCode, item.name)}
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                          item.productCode ==
                            SERVICE_PRODUCT_CODES.DirectRouting
                            ? PRODUCT_NAMES.TPS
                            : item.name
                        }
                        secondary={
                          <StyledCaption>
                            <span>
                              {getStatusLabel(item.orderStatus)}
                            </span>
                          </StyledCaption>
                        }
                      />
                    </ListItem>
                  </List>
                </Stack>
              </div>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </>
  )
}
